import {Form as FormRff} from 'react-final-form';
import React, {createContext, forwardRef, useContext} from "react";

/**
 * @typedef {import("react-final-form/typescript/index").FormApi} formApi
 */

/**
 * The context for providing the form inside the form-related components.
 * @type {React.Context<formApi | null>}
 */
const FormContext = createContext(null);
/**
 * A hook that exposes the FormContext's value to the using component.
 */
export const useFormOld = () => useContext(FormContext);

/**
 *
 * @param {any} subscription the subscription of the FormRff
 * @param {string} id the ID of the <form /> tag
 * @param {string} className applied to the inner <form /> tag
 * @param autoFillValues applied to the inner <form /> tag
 * @param {import("react-final-form/typescript/index").FormProps &
 *     React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>} props
 * @param {function(props: import("react-final-form/typescript/index").RenderableProps)} render
 * @return {JSX.Element}
 * @constructor
 */
const Form = forwardRef(({
                             subscription,
                             autoFillValues,
                             className,
                             id,
                             render,
                             ...props
                         }, ref) => {
    return (
        <FormRff
            subscription={subscription}
            {...props}
            render={({handleSubmit, ...props}) => {
                return (
                    <FormContext.Provider value={props.form}>
                        <form
                            ref={ref}
                            id={id}
                            className={className}
                            onSubmit={handleSubmit}
                            noValidate
                            autoComplete={autoFillValues}
                        >
                            {render(props)}
                        </form>
                    </FormContext.Provider>
                )
            }}
        />
    );
});


export default Form;
